import React from 'react';
import { Route } from 'react-router';

import Appointments from '../../components/Pages/Appointments';


const routes = <Route path="appointments" component={Appointments.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/appointments.js